import API from '../api.js';

export default {
  /**
   * Will add api to Vue instance
   *
   * @param {*} Vue
   */
  install(Vue, options) {
    Object.defineProperties(Vue.prototype, {
      $api: {
        get() {
          const {
            client,
            regexp = {
              '$1/$2': /([a-z])([A-Z])/g,
              '/$/': /\$/g,
            },
          } = options;

          return API(client, regexp);
        },
      },
    });
  },
};
